import $ from 'jquery';
import _ from 'lodash';
import Highcharts from 'highcharts';
import message from '../../../../../utils/message';

/*

 【テスト（オリジナルテスト）】
 No,配信名,問題数,配信者名,クラス,開始日時,終了日時,平均点,受験率

 */

function buildChart($csv_chart_area, csv_download_url, papa_data) {
  // ヘッダーを削除
  papa_data.data.shift();
  console.log(papa_data.data);
  let categories = [];
  let chart_labels = [];
  // クラス種別のリストを作成
  categories = _.map(papa_data.data, o => o[4]);
  categories = _.uniq(categories);

  // ホームワーク種別のリストを作成
  chart_labels = _.map(papa_data.data, o => o[1]);
  chart_labels = _.uniq(chart_labels);

  const chart_data = [];

  _.each(chart_labels, (label) => {
    const hwName = label;
    chart_data.push({
      name: hwName,
      data: _.map(categories, (o) => {
        const className = o;
        let shintyoku = 0;

        const hw = _.find(papa_data.data, row => row[1] === hwName && row[4] === className);

        if (hw === undefined) {
          shintyoku = '';
        } else {
          shintyoku = Number(hw[7]);
        }
        return shintyoku;
      }),
    });
  });

  console.log(chart_data);

  $csv_chart_area.highcharts({
    chart: {
      type: 'bar',
    },
    title: {
      text: message.testScoreByClass,
    },
    xAxis: {
      categories,
      title: {
        text: message.className,
      },
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: message.averageScoreLatest,
        align: 'high',
      },
      labels: {
        // overflow: 'justify',
      },
    },
    plotOptions: {
      bar: {
        // dataLabels: {
        //   enabled: true,
        // },
      },
    },
    series: chart_data,
  });
}

export default buildChart;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/charts/selectedtraining/sttest_result.js